import React from 'react';
import { WrapperStyle } from './style';

export default function WrapperListHeader() {
  return (
    <WrapperStyle>
      <h2>Seus Faturamentos:</h2>
      <a href={`sincroniza-nfe/criar-faturamento`}>Novo Faturamento +</a>
    </WrapperStyle>
  );
}
